import { Injectable } from "@angular/core";
import { SelectOption } from "projects/pax-ui/components";
import { concatMap, map, Observable } from "rxjs";
import { BaseStaticDataFormService } from "../../base-static-data-form.service";
import { NationalityHttpService } from "./nationality-http.service";

@Injectable({
  providedIn: "root",
})
export class NationalityFormService extends BaseStaticDataFormService {
  readonly shareReplayNationalityOptions$: Observable<SelectOption[]>;

  constructor(private readonly _nationalityService: NationalityHttpService) {
    super();
    this.shareReplayNationalityOptions$ =
      this.initializeNationalityOptionObservable();
  }

  private initializeNationalityOptionObservable() {
    return this.createDefaultHttpObservable().pipe(
      concatMap(() => this._nationalityService.get()),
      map((response) => {
        return response.nationalities.map((nationalityDto) => {
          const selectionOption: SelectOption = {
            label: nationalityDto.country,
            value: nationalityDto.code,
            disabled: false,
          };

          return selectionOption;
        });
      }),
      this.createShareReplayObservable(),
    );
  }
}
